// extracted by mini-css-extract-plugin
export default {"hero":"HeroImage_hero__UrBZr","heroImage":"HeroImage_heroImage__7rL9a","heroOverlay":"HeroImage_heroOverlay__YD4fR","heroText":"HeroImage_heroText__qZhVL"};